import { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box, Button, TextField, MenuItem, Select, Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import { PersonAdd, Delete } from "@mui/icons-material";

export default function Administrateur() {
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [nom, setNom] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState(""); // Ajout du champ mot de passe
  const [role, setRole] = useState("conseiller");
  const [openUserModal, setOpenUserModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  useEffect(() => {
    fetchUtilisateurs();
  }, []);

  const BACKEND_URL =
    window.location.hostname === "localhost"
      ? process.env.REACT_APP_BACKEND_URL_LOCAL + "/api"
      : process.env.REACT_APP_BACKEND_URL_PROD + "/api";

  // 📌 Récupération des utilisateurs
  const fetchUtilisateurs = async () => {
    try {
        const token = localStorage.getItem("token");

        if (!token) {
            console.error("⚠️ Aucun token trouvé, impossible de récupérer les utilisateurs.");
            return;
        }

        console.log("📡 Envoi de la requête pour récupérer les utilisateurs...");
        const res = await axios.get(`${BACKEND_URL}/utilisateurs`, {
            headers: { Authorization: `Bearer ${token}` },
        });

        console.log("✅ Réponse API reçue :", res.data);
        
        if (!Array.isArray(res.data)) {
            console.error("❌ Les données reçues ne sont pas sous forme de tableau :", res.data);
            return;
        }

        setUtilisateurs(res.data);
    } catch (err) {
        console.error("❌ Erreur lors de la récupération des utilisateurs :", err.response?.data || err);
    }
};

  // 📌 Ajout d'un utilisateur
  const ajouterUtilisateur = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!nom || !email || !password) {
        alert("Veuillez remplir tous les champs.");
        return;
      }

      await axios.post(`${BACKEND_URL}/utilisateurs/register`,
        { Nom: nom, Email: email, Password: password, Rôle: role },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      fetchUtilisateurs();
      setNom("");
      setEmail("");
      setPassword(""); // Réinitialisation du champ mot de passe
      setRole("conseiller");
      setOpenUserModal(false);
    } catch (err) {
      console.error("❌ Erreur ajout utilisateur :", err);
      alert("Erreur lors de l'ajout de l'utilisateur.");
    }
  };

  // 📌 Suppression d'un utilisateur
  const supprimerUtilisateur = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${BACKEND_URL}/utilisateurs/${selectedUserId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchUtilisateurs();
      setConfirmDelete(false);
      setSelectedUserId(null);
    } catch (err) {
      console.error("❌ Erreur suppression utilisateur :", err);
    }
  };

  // 📌 Définition des colonnes du tableau
  const columns = [
    { field: "Nom", headerName: "Nom", width: 200 },
    { field: "Email", headerName: "Email", width: 250 },
    { field: "Rôle", headerName: "Rôle", width: 150 },
    {
      field: "actions",
      headerName: "Actions",
      width: 130,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="error"
          size="small"
          startIcon={<Delete />}
          onClick={() => {
            setSelectedUserId(params.row._id);
            setConfirmDelete(true);
          }}
        >
          Supprimer
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", my: 3 }}>
        <Button variant="contained" color="primary" startIcon={<PersonAdd />} onClick={() => setOpenUserModal(true)}>
          Ajouter un utilisateur
        </Button>
      </Box>
      <DataGrid
        rows={utilisateurs}
        columns={columns}
        pageSizeOptions={[5, 10]}
        initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
        getRowId={(row) => row._id}
        sx={{ height: 400, backgroundColor: "white" }}
      />

      {/* Modal d'ajout d'utilisateur */}
      <Dialog open={openUserModal} onClose={() => setOpenUserModal(false)}>
        <DialogTitle>Ajouter un utilisateur</DialogTitle>
        <DialogContent>
          <TextField 
            label="Nom" 
            value={nom} 
            onChange={(e) => setNom(e.target.value)} 
            fullWidth 
            sx={{ my: 2 }} 
          />
          <TextField 
            label="Email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            fullWidth 
            sx={{ my: 2 }} 
          />
          <TextField 
            label="Mot de passe" 
            type="password"
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            fullWidth 
            sx={{ my: 2 }} 
          />
          <Select 
            value={role} 
            onChange={(e) => setRole(e.target.value)} 
            fullWidth 
            sx={{ my: 2 }}
          >
            <MenuItem value="Administrateur">Administrateur</MenuItem>
            <MenuItem value="Associé">Associé</MenuItem>
            <MenuItem value="Family Officer">Family Officer</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenUserModal(false)} color="secondary">Annuler</Button>
          <Button onClick={ajouterUtilisateur} color="primary" variant="contained">Ajouter</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
